import axios from 'axios';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import authApis from '../../../APIs/auth';
// import FaceBook from '../../../assets/icons/facebookIcon.svg';
// import Google from '../../../assets/icons/Google.svg';
import handsake from '../../../assets/icons/handSake.svg';
// import Linkedin from '../../../assets/icons/linkedinIcon.svg';
import lock from '../../../assets/icons/Lock.svg';
import logo from '../../../assets/icons/logo.svg';
import mail from '../../../assets/icons/Mail.svg';
import escConstants from '../../../constants';
import { useRoot } from '../../../context/RootProvider';
import {
  Alert,
  Button,
  // Divider,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import {
  DASHBOARD_ROUTE,
  VERIFICATION_ROUTE,
} from '../../../routes/routePaths';
// import { DASHBOARD_ROUTE } from '../../../routes/routePaths';
import { connectSocket } from '../../../socket';
import theme from '../../../theme';
import { requestAPI } from '../../../utils';
import {
  // AlternativeLogin,
  // AlternativeLoginContainer,
  ContentContainer,
  Heading,
  Label,
  LoginContainer,
  Logo,
} from './style';
import validation from './validation';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isClickedEyeButton, setIsClickedEyeButton] = useState(false);

  const navigate = useNavigate();
  const { updateAuth } = useRoot();

  const handleLogin = async (values: any) => {
    try {
      setErrorMessage('');
      setLoading(true);
      const loginData = await requestAPI(authApis.login(values));

      if (loginData?.user?._id) {
        updateAuth({
          ...loginData?.user,
          ...loginData?.profile,
        });
        localStorage.setItem(
          escConstants.LOCAL_STORAGE_KEY.accessKey,

          loginData?.token,
        );
        axios.defaults.headers.Authorization = `Bearer ${loginData?.token}`;

        localStorage.setItem(
          escConstants.LOCAL_STORAGE_KEY.refreshKey,
          loginData?.refreshToken,
        );
        toast(escConstants.toastMessages.login);
        const userData = loginData?.user;

        if (!userData?.hasEmailVerified) {
          return navigate(VERIFICATION_ROUTE);
        }
        // if (!userData?.isOnboardingCompleted) {
        //   return navigate(`${ONBOARDING_ROUTE}/${userData.onboardingStep + 1}`);
        // }
        connectSocket(loginData?.token);
        navigate(DASHBOARD_ROUTE);
      }

      setLoading(false);
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      setLoading(false);
      console.error('Login failed:', error);
    }
  };
  return (
    <LoginContainer>
      <ContentContainer>
        <Heading>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Typography variant="heading" strong>
              Evacuation Plans
            </Typography>
            <Typography style={{ marginLeft: '45px', color: '#3D3D3D' }}>
              SaaS Application
            </Typography>
          </div>
          <div>
            <Logo src={logo} alt="logo" />
          </div>
        </Heading>

        <Label>
          <img src={handsake} alt="handsake" />
          <Typography size={16} color={theme.colors.normalText}>
            Welcome to Escape Plan
          </Typography>
        </Label>
        <Formik
          initialValues={{
            emailAddress: '',
            password: '',
          }}
          onSubmit={handleLogin}
          enableReinitialize
          validationSchema={validation.Login}
        >
          {({ values, setFieldValue, errors, handleSubmit, touched }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <FormContainer
                  label="Email Address"
                  error={touched?.emailAddress ? errors.emailAddress : ''}
                  marginBottom="20px"
                >
                  <Input
                    name="emailAddress"
                    value={values.emailAddress}
                    onChange={(e) =>
                      setFieldValue('emailAddress', e.target.value)
                    }
                    placeholder="Enter emailAddress"
                    iconLeft={<img src={mail} alt="mail icon" />}
                  />
                </FormContainer>

                <FormContainer
                  label="Password"
                  error={touched?.password ? errors.password : ''}
                  marginBottom="20px"
                >
                  <Input
                    type={isClickedEyeButton ? 'text' : 'password'}
                    name="password"
                    value={values.password || ''}
                    onChange={(e) => setFieldValue('password', e.target.value)}
                    placeholder="Enter password"
                    iconLeft={<img src={lock} alt="lock" />}
                    iconRight={
                      <div
                        role="button"
                        onClick={() => setIsClickedEyeButton((prev) => !prev)}
                      >
                        {isClickedEyeButton ? (
                          <IoEyeOutline size={18} />
                        ) : (
                          <IoEyeOffOutline size={18} />
                        )}
                      </div>
                    }
                  />
                </FormContainer>
                {errorMessage && <Alert text={errorMessage} type="error" />}

                <Typography
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginBottom: '30px',
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate('/forget-password')}
                >
                  Forgot Password?
                </Typography>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  width="100%"
                  style={{ marginBottom: '15px' }}
                  isLoading={loading}
                >
                  Login
                </Button>
              </Form>
            );
          }}
        </Formik>
        <Typography
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: '#616161',
          }}
        >
          Don’t have an account?{' '}
          <span
            style={{
              color: '#3D3D3D',
              marginLeft: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
            onClick={() => {
              navigate('/register');
            }}
          >
            Create Account
          </span>
        </Typography>
      </ContentContainer>
      {/* <Divider text="or you can" />
      <AlternativeLoginContainer>
        <Button variant="gray" size="lg" width="100%">
          <AlternativeLogin>
            <img src={FaceBook} alt="facebook" />
            Login with Facebook
          </AlternativeLogin>
        </Button>
        <Button variant="gray" size="lg" width="100%">
          <AlternativeLogin>
            <img src={Google} alt="google"/>
            Login with Google
          </AlternativeLogin>
        </Button>
        <Button variant="gray" size="lg" width="100%">
          <AlternativeLogin>
            <img src={Linkedin} alt="linkedin"/>
            Login with Linkedin
          </AlternativeLogin>
        </Button>
      </AlternativeLoginContainer> */}
    </LoginContainer>
  );
};

export default Login;
